"use client";

import { useEffect } from "react";
import { RoomDetails } from "commonModule/services/common";
import NewBedroomIcon from "components/icons-svg/NewBedroomIcon";
import ImageWithFallback from "components/utilities/ImageWithFallback";
const Room = ({
  room,
  className = ""
}: {
  room: RoomDetails;
  className?: string;
}) => {
  const formatBedDescription = (description: string) => description?.replace(
  // eslint-disable-next-line regexp/no-unused-capturing-group
  /(\d+)\s+([A-Z]+(?:\s+[A-Z]+)*)\s+Bed(s?)/gi, (_, count: string, type: string) => `${count} ${type} Bed${Number(count) === 1 ? "" : "s"}`);
  const bedsDesc = formatBedDescription(room?.Description || "")?.split("\n") || [];
  return <div key={room.Name} className={`rounded-lg border border-[#EEEEEE] px-4 py-2 ${className}`} data-sentry-component="Room" data-sentry-source-file="RoomDetails.tsx">
      <p className='mb-2 line-clamp-1 text-sm font-semibold !leading-7 text-brand-dark lg4:text-base'>
        {room.Name}
      </p>
      <div className='flex items-center justify-start gap-x-2'>
        <div className='flex flex-col items-start gap-2'>
          {room.ImageURL ? room.ImageURL?.split(",").filter(x => x.trim()).map((url, i) => {
          const isTwinBedImg = url.includes("Twin_Bed");
          return <div key={`bedImage ${i}`} className='flex items-center gap-2'>
                    <ImageWithFallback className='min-w-[24px] opacity-50' height={24} width={isTwinBedImg ? 44 : 24} src={url} key={`bedImage ${i}`} alt={room.Name || "Bed Icon"} postfix={null} fallbackSrc={"https://whimstay-staging-bucket.s3.us-east-2.amazonaws.com/Whimstay/room-details/King_bed"} />
                    <p className='w-full text-sm font-medium !leading-7 text-Gray-700 md:text-grayText'>
                      {bedsDesc?.[i]?.trim()}
                    </p>
                  </div>;
        }) : <ImageWithFallback className='min-w-[24px] opacity-50' alt='King_bed' height={24} width={24} src={"https://whimstay-staging-bucket.s3.us-east-2.amazonaws.com/Whimstay/room-details/King_bed"} />}
        </div>
      </div>
    </div>;
};
const RoomDetailsSlider = ({
  roomDetails
}: {
  roomDetails: RoomDetails[];
}) => {
  useEffect(() => {
    const slides = document.querySelectorAll(".splide__slide");
    slides.forEach(slide => {
      if (slide.getAttribute("role") === "group") {
        slide.setAttribute("role", "listitem");
      }
    });
  }, []);
  return <>
      <div className='my-8 h-[1px] bg-grayBorder'></div>
      <div id='where_you_will_be_section' className='scroll-mt-28 bg-white'>
        <div className='mb-4 flex items-center gap-2 md:mb-6'>
          <NewBedroomIcon className='h-[14px] w-[16px] md:h-[17.5px] md:w-[20px]' data-sentry-element="NewBedroomIcon" data-sentry-source-file="RoomDetails.tsx" />
          <h3 className='text-base font-semibold leading-[19.2px] tracking-[-0.24px] text-secondary500 md:text-xl md:leading-6 md:tracking-[-0.3px]'>
            Sleeping arrangements
          </h3>
        </div>
        <div className={`grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg2:gap-6`}>
          {roomDetails && roomDetails.map(room => <Room key={room.Name} room={room} className='w-full' />)}
        </div>
      </div>
    </>;
};
export default RoomDetailsSlider;